import type { ParentComponent } from 'solid-js'

/**
 * Top-level layout shell wrapping the app's header, content, and footer.
 *
 * @param props - The child content.
 * @returns The shell element.
 */
const AppShell: ParentComponent = props => (
   <div class="w-full max-w-4xl mx-auto flex flex-col gap-4 px-3 py-4 sm:px-4 sm:py-5 sm:bg-surface-raised/80 sm:backdrop-blur sm:rounded-2xl sm:shadow-2xl lg:px-6 lg:py-6 lg:grid lg:grid-cols-[360px_1fr] lg:gap-7">
      {props.children}
   </div>
)

export default AppShell
